export default "__VITE_ASSET__CK6RnF3W__"